/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_Skill_CountInputs */

const en_tables_pause_reasons_skill_count = /** @type {(inputs: Tables_Pause_Reasons_Skill_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Skill Count`)
};

const de_tables_pause_reasons_skill_count = /** @type {(inputs: Tables_Pause_Reasons_Skill_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Skills`)
};

/**
* | output |
* | --- |
* | "Reasons Skill Count" |
*
* @param {Tables_Pause_Reasons_Skill_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_skill_count = /** @type {((inputs?: Tables_Pause_Reasons_Skill_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_Skill_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_skill_count(inputs)
	return de_tables_pause_reasons_skill_count(inputs)
});